export default __webpack_public_path__ + "static/media/2.55fe5ec4.png";